export const TOGGLE_LEFT_MENU = 'TOGGLE_LEFT_MENU'

export const toggleLeftMenu = () => {
  return {
    type: TOGGLE_LEFT_MENU
  }
}
